import { ToastOptions, Bounce } from 'react-toastify';

export const toastConfig: ToastOptions = {
  position: 'bottom-right',
  autoClose: 7000,
  hideProgressBar: false,
  closeOnClick: true,
  rtl: false,
  pauseOnFocusLoss: false,
  draggable: true,
  pauseOnHover: true,
  theme: 'light',
  transition: Bounce,
};
